export default {
    initialized: false,
    shipment: {},
    showPickup: false,
    backendErrors: [],
    servicePrices: [],
    bookingOptions: [],
    defaultValues: [],
    companyAccountAddresses: [],
    addressBook: [],
    packagingTypes: [],
    shipmentPackaging: [],
    dangerousGoodsTypes: [],
    dangerousGoodsDescriptions: [],
    exportReasonCode: [],
    shippingOptions: {},
    isColliDimension: true,
    isReceiverPays: false,
    isDangerousGoods: false,
    selectedCompanyId: 0,
    labelUrl: '',
    trackingNumber: "",
    insuranceAmountRequired: false,
    customerDescriptions: [],
    referenceTypes: [],
    prototype: {}
};
